import { useEffect, useRef } from "react";
import { useInView, useMotionValue, useSpring } from "framer-motion";
import { Reveal, Overline } from "./Reveal";

const STATS = [
  { value: 500, suffix: "+", label: "Global Clients" },
  { value: 70, suffix: "+", label: "Worldwide SSP Partners" },
  { value: 10, suffix: "K+", label: "Publisher Websites & Apps" },
  { value: 10, suffix: "+", label: "Service Verticals" },
];

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const mv = useMotionValue(0);
  const spring = useSpring(mv, { duration: 2.2, bounce: 0 });

  useEffect(() => {
    if (inView) mv.set(value);
  }, [inView, value, mv]);

  useEffect(() => {
    const unsub = spring.on("change", (v) => {
      if (ref.current) ref.current.textContent = `${Math.round(v)}${suffix}`;
    });
    return unsub;
  }, [spring, suffix]);

  return <span ref={ref}>0{suffix}</span>;
};

export const Stats = () => (
  <section id="results" data-testid="stats-section" className="py-24 md:py-32 border-t border-white/10 bg-[#121214]">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <Reveal className="mb-16">
        <Overline>Proof, Not Promises</Overline>
      </Reveal>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-y-16">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.1}>
            <div className="border-l border-white/10 pl-6 md:pl-10" data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="font-accent text-5xl md:text-7xl text-[#F8F8F8] tracking-tight">
                <Counter value={s.value} suffix={s.suffix} />
              </div>
              <p className="mt-4 font-accent text-xs tracking-[0.3em] uppercase text-[#52525B]">{s.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
